import memoize from 'lodash/memoize';

export default memoize((pxs) => `${pxs / 16}rem`);
